import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';
import { ImportEndpoint } from '@api/endpoints';
import { ErrorType, ImportType } from '@shared/enums';

export class ImportApi {
  static getTemplate (importType: ImportType): Promise<string> {
    return Client(`import/template/${importType}`);
  }

  static getHistory (
    query: ImportEndpoint.GetHistory.Query,
  ): Promise<ImportEndpoint.GetHistory.Response> {
    const queryString = QueryUtil.stringify(query);
    return Client(`import/history?${queryString}`);
  }

  static getImportErrors (
    importHistoryId: string,
    errorType?: ErrorType,
  ): Promise<ImportEndpoint.GetImportErrors.Response> {
    const query = errorType && QueryUtil.stringify({ errorType });
    return Client(`import/history/${importHistoryId}/errors?${query}`);
  }

  static getUploadUrl (
    retailerId: string,
    importType: ImportType,
    fileName: string,
  ): Promise<ImportEndpoint.GetUploadUrl.Response> {
    const queryString = QueryUtil.stringify({ fileName });
    return Client(`retailer/${retailerId}/import/${importType}/upload-url?${queryString}`);
  }

  static import (retailerId: string, storageKey: string, importType: ImportType) {
    return Client(`retailer/${retailerId}/import/${importType}`, {
      body: { storageKey },
      method: 'POST',
    });
  }
}
